<template>
  <div>


    <div class="system-message" v-if="this.showSystemMessage">
      <template>
        <div class="content p-0 m-0" style="width: 100%">
          <div class="has-text-centered">
            <h5 class="p-1" style="font-weight: bold; color: #126382">{{translate('NewSystemMessage')}}</h5>
          </div>
          <div class="has-text-centered p-0 m-0" style="background-color: #126382;">
          <h1 class="p-1" style="color: white; font-weight: bold">{{this.systemMessage.title}}</h1>
          </div>
          <div>
          <p class="pl-1" style="color: #126382">{{translate('Category')}} {{this.systemMessage.systemMessageCategory}}</p>
          </div>
          <div>
          <h6 class="pl-1" style="color: #126382">{{translate('Author')}} {{this.systemMessage.author}}</h6>
          </div>
          <div style="width: 100%; border-bottom: #3e8ed0 1px solid;" class="p-0 m-0"/>
          <div class="p-1">
            <div v-html="this.systemMessage.content"></div>
          </div>
        </div>
        <div class="p-0 m-0 has-text-centered">
          <b-button style="background-color: #126382; color: white; font-weight: bold" expanded label="Ok." @click="saveTheSeenSystemMessageId()"></b-button>
        </div>
      </template>
    </div>

    <div class="login-selection-container">
      <div v-if="isThereOngoingMaintenance" class='under-maintenance'>
        <h1 class="subtitle has-text-primary">
          {{ translate('Maintenance') }}
        </h1>
      </div>
    </div>
  </div>

</template>

<script>
import keycloak from "@/security/keycloak";
import backendService from "@/service/backendService";
import {formatDateTime} from "../../utils";
import {lang} from "@/lang";


export default {
  name: "LoginSelection",
  props: {
    isTranslated: Boolean,
  },
  data() {
    return {

      loading: false,
      isThereOngoingMaintenance: false,
      showSystemMessage: false,
      systemMessage: {
        author: null,
        content: null,
        createTs: null,
        id: null,
        systemMessageCategory: null,
        title: null
      }
    }
  },
  methods: {
    login() {
      this.loading = true;
      if (!this.isAuthenticated()) {
        setTimeout(keycloak.login, 0);
      } else {
        this.continueLogin();
      }
    },
    logout() {
      this.loading = true;
      setTimeout(keycloak.logout, 0);
    },
    continueLogin() {
      this.$emit("continue-login");
    },
    // continueAsGuest() {
    //     this.$emit("continue-as-guest");
    // },
    saveTheSeenSystemMessageId() {
      window.localStorage.setItem("latestMessageid", this.systemMessage.id)
      this.showSystemMessage = false
      this.login();
    },
    getLatestSystemMessage() {
      backendService.getLatestSystemMessage().then(data => this.systemMessage = data)
      this.showSystemMessage = true
    },
    getIsThereOngoingMaintenance() {
      backendService.getIsThereOngoingMaintenance().then(data => this.isThereOngoingMaintenance = data)
    },
    getLoginMessage() {
      if (keycloak.authenticated) {
        if (this.$props.isTranslated)
          return "Continue as " + keycloak.tokenParsed.family_name + " " + keycloak.tokenParsed.given_name;
        else
          return "Folytatás mint " + keycloak.tokenParsed.family_name + " " + keycloak.tokenParsed.given_name;
      } else
        return this.translate('LoginBtn');
    },
    isAuthenticated() {
      return keycloak.authenticated;
    },
    translate(property) {
      return this.$props.isTranslated ? lang['en'][property] : lang['hu'][property]
    },
    formatDateTime
  },
  mounted() {
    this.showSystemMessage = true;
    this.getIsThereOngoingMaintenance();
    this.getLatestSystemMessage();
    let btnLogin = this.$refs["btn-login"];
    btnLogin.$el.focus();
  },

}
</script>

<style scoped>

</style>